<template>
  <v-container fluid>
    <v-layout justify-center align-start v-if="!data._id" class="printNone">
      <v-flex xl2 md4 sm6 xs12>
        <v-card class="br-10 pa-4 text-center">
            <div class="title pa-3">{{ $t('no_account_selected') }}</div>
            <v-layout row wrap pt-2 justify-center>
              <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" round type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
            </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('feedback_info') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-bookmark fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data._id }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-calendar fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.date | dateTime }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('date') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-map-pin fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.subject }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('subject') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-stack-exchange fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.description }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('description') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-info-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ $t(data.status) }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-headphones fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.channel }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('channel') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <br>
    <v-list two-line class="br-10" dense v-if="data._id">
      <v-subheader><h3>{{ $t('user_details') }}</h3></v-subheader>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-user-circle fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.full_name }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('name', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-id-card fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.ic_num }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('ic_num') }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-phone fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.phone }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('phone', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon color="primary lighten-2" class="pl-2">fa-at fa-lg</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title class="body-2">{{ data.complainant.email }}</v-list-item-title>
          <v-list-item-subtitle class="body-2">{{ $t('email', { field: '' }) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
import vuex from 'vuex'

export default {
  beforeMount () {
    this.fetchData({ id: this.$route.params.id })
  },
  computed: {
    ...vuex.mapState({
      data: state => state.feedback.data
    })
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'feedback/fetchData'
    })
  }
}
</script>
